import type { SearchQueryBody } from "@/types";

/**
 * TanStack-Query key factory for session-list reads. The hierarchy
 * `all` ⊃ `lists()` ⊃ `list(orgId, query)` lets mutations invalidate at
 * the broadest level they affect. Mirrors `eventQueryKeys`.
 */
export const sessionQueryKeys = {
  all: ["sessions"] as const,
  lists: () => [...sessionQueryKeys.all, "list"] as const,
  // Collapse missing and empty-body calls onto the same cache slot.
  list: (orgId: string | undefined, query?: SearchQueryBody) => {
    if (!query || Object.keys(query).length === 0) {
      return [...sessionQueryKeys.lists(), orgId] as const;
    }
    return [...sessionQueryKeys.lists(), orgId, query] as const;
  },
};
